module.exports = __webpack_public_path__ + "static/media/rv_mid.0e89187f.jpeg";